import { useMutation } from '@apollo/client';

/**
 * @description Custom hook to update the cache
 * @param {string} updateQuery - Mutation query
 * @param {Function} updateCacheFn - callback function to update the cache
 * @param {Function} successCallback - Function to call on success
 * @param {Function} errorCallback - Function to call on error
 * @returns {Function} updateFn
 */
const useMutationUpdateCache = (
  updateQuery,
  updateCacheFn,
  successCallback,
  errorCallback
) => {
  const [updateFn] = useMutation(updateQuery, {
    onError(err) {
      errorCallback(err);
    },
    update(cache, ...otherParams) {
      updateCacheFn(cache, ...otherParams);
    },
    onCompleted() {
      successCallback();
    },
  });

  return { updateFn };
};

export default useMutationUpdateCache;
